import Vue from 'vue';
import { DataService } from '../../data.service';
import { landcoverClasses as legend } from '../../../config/chart-legends';

const chartID = 'getCountyDistributionLossesGains';
/**
 * Tab 1: General: Distribution Of Change (Losses & Gains) By Land Cover
 * getCountyDistributionLossesGains
 */
export class Tab1Chart3 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas[0]);
                this.updateChartData(response.data.LandCoverAtlas[0]);
            }
        })
        this.renderChart();
    }

    updateChartData(response) {
        this.chart.chartOptions.series[0].data = response.data.gain;
        this.chart.chartOptions.series[1].data = response.data.loss;
        this.chart.chartOptions.xAxis.categories = response.data.categoryAbbr;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Distribution Of Change (Losses & Gains) By Land Cover',
                        loading: true
                    },
                    animationDuration: 1000,
                    updateArgs: [true, true, { duration: 1000 }],
                    chartOptions: {
                        chart: {
                            type: 'bar',
                            marginTop: 40
                        },
                        plotOptions: {
                            series: {
                                stacking: 'normal'
                            }
                        },
                        colors: ['#336699', '#CBDCF2'],
                        xAxis: {
                            title: {
                                text: 'Land Cover Classes'
                            },
                            categories: ['HID', 'MID', 'LID', 'OSD', 'CRP', 'PAS', 'GRS', 'DFO', 'EFO', 'MFO', 'SHB', 'WDW', 'EHW', 'BRN', 'WTR', 'PIS'],
                        },
                        yAxis: {
                            title: {
                                text: 'Square Miles'
                            }
                        },
                        tooltip: {
							shared: true,
                            formatter: function () {
								let tooltip = '';
								for(let i=0; i < this.points.length; i++) {
									if(i != 0) {
										tooltip += '<br>-------<br>'
									}
									tooltip += '<b>' + this.points[i].series.name + '</b><br>' + legend[this.x].name + '<br><b>' + this.points[i].y + '</b> square miles';
								}
								return tooltip;
                            }
                        },
                        series: [
                            {
                                name: 'Gain',
                                data:
                                    [
                                        107, 31, 35, 203, 21, 32, 12, 5, 120, 25, 32, 12, 5, 120, 25, 32 
                                    ]
                            },
                            {
                                name: 'Loss',
                                data:
                                    [
                                        107, 31, 35, 203, 21, 32, 12, 5, 120, 25, 32, 12, 5, 120, 25, 32 
                                    ]
                            }
                        ]
                    }
                }
            }
        });
        //end vue component
    }
}
